var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "handover-information" },
    [
      _c(
        "Sticky",
        {
          staticClass: "sticky-btn",
          class: _vm.isTenantClass,
          attrs: {
            extendStickyClass: "stick-class",
            fullWidth: false,
            align: "right",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isTenant,
                  expression: "!isTenant",
                },
              ],
              staticClass: "btnGroup",
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.isEdit && (_vm.allowEditDate || _vm.allowApprove),
                      expression: "isEdit && (allowEditDate || allowApprove)",
                    },
                  ],
                  staticClass: "btn--darkblue cancel-btn",
                  on: { click: _vm.discardChanges },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.cancel")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.allowEdit &&
                        !_vm.isEdit &&
                        (_vm.allowEditDate || _vm.allowApprove),
                      expression:
                        "!allowEdit && !isEdit && (allowEditDate || allowApprove)",
                    },
                  ],
                  staticClass: "btn--orange edit-btn",
                  on: { click: _vm.enableEdit },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.edit")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.allowEdit || (_vm.isEdit && _vm.allowApprove),
                      expression: "(allowEdit || (isEdit && allowApprove))",
                    },
                  ],
                  class: _vm.saveButtonClass,
                  on: { click: _vm.save },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.save")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("SubmitHandover", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.allowEdit || (_vm.isEdit && _vm.allowEditDate),
                    expression: "(allowEdit || (isEdit && allowEditDate))",
                  },
                ],
                attrs: {
                  options: _vm.approvers,
                  resetValidation: _vm.resetValidation,
                  validate: _vm.validate,
                  disabled: !_vm.allowEdit,
                },
                on: { "hotb:approve": _vm.approve },
              }),
              _vm._v(" "),
              _c("approval", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.isEdit && _vm.allowApprove,
                    expression: "!isEdit && allowApprove",
                  },
                ],
                staticClass: "handover-reject approval",
                attrs: {
                  id: "handover-reject",
                  btnName: _vm.$t("action.reject"),
                  btnClass: "btn--darkblue",
                  updateStatus: _vm.reject,
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEdit && _vm.allowApprove,
                      expression: "!isEdit && allowApprove",
                    },
                  ],
                  staticClass: "btn--orange approval",
                  attrs: { id: "handover-approve" },
                  on: { click: _vm.approve },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("action.approve")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.isEdit && _vm.allowInvite && !_vm.isSpecial,
                      expression: "!isEdit && allowInvite && !isSpecial",
                    },
                  ],
                  staticClass: "btn--orange",
                  on: {
                    click: function ($event) {
                      return _vm.showInviteModal()
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("handover.arrangeNotify")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hkldHotbContacts.length && _vm.isTenant && !_vm.isCompleted
            ? _c(
                "DialogSlot",
                {
                  ref: "fillRequestChange",
                  staticClass: "item tenant-handover-request-change-btn",
                  attrs: {
                    id: "tenant-hotb-request-change",
                    modalBtn: _vm.$t("action.requestChange"),
                    modalBtnClass: "btn--darkblue",
                    beforeCloseModal: function () {
                      return _vm.beforeCloseRequestChangeModal()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "request-change-comment",
                      attrs: { slot: "content" },
                      slot: "content",
                    },
                    [
                      _c("p", { staticClass: "font-bold" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("hint.changeHandover")) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("TextField", {
                        attrs: {
                          required: "",
                          value: _vm.requestChangeComments,
                        },
                        on: {
                          updateValue: function (val) {
                            return (_vm.requestChangeComments = val)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "buttons" }, slot: "buttons" },
                    [
                      _c(
                        "DialogSlot",
                        {
                          ref: "requestChange",
                          attrs: {
                            id: "tenant-hotb-request-change-submitted",
                            modalBtn: _vm.$t("action.continue"),
                            modalBtnClass: "btn--orange",
                            beforeOpenModal: _vm.requestChange,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "font-bold",
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("hint.changedRequested")) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { attrs: { slot: "buttons" }, slot: "buttons" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn--darkblue",
                                  on: {
                                    click: function ($event) {
                                      return _vm.closeModal()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("action.ok")) +
                                      "\n            "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.isTenant
        ? _c("div", { staticClass: "basicInfo" }, [
            _c("div", { staticClass: "basicItem" }, [
              _c(
                "div",
                {
                  staticClass: "title",
                  class: { "required-flag": _vm.allowEdit },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("company.basic.companyName")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "value" },
                [
                  _vm.allowEdit
                    ? _c("HKLInput", {
                        key: _vm.companyNameKey,
                        attrs: { value: _vm.companyName },
                        on: { blur: _vm.updateCompanyName },
                      })
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.companyName) +
                            "\n        "
                        ),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basicItem" }, [
              _c(
                "div",
                {
                  staticClass: "title",
                  class: { "required-flag": _vm.allowEdit },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("tenancy.tradeName")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "value" },
                [
                  _vm.allowEdit
                    ? _c("HKLInput", {
                        key: _vm.tradeNameKey,
                        attrs: { value: _vm.tradeName },
                        on: { blur: _vm.updateTradeName },
                      })
                    : [
                        _vm._v(
                          "\n          " + _vm._s(_vm.tradeName) + "\n        "
                        ),
                      ],
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basicItem building" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("tenancy.building")) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.deep(_vm.currentHotb, "tenancy.building.code")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basicItem status" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("status.name")) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "value status-text",
                  on: { click: _vm.openLifecycleModal },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm._f("customStatusLabel")(_vm.currentHotb.status)
                      ) +
                      "\n      "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "basicItem lastUpdateOnandBy" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("handover.lastUpdateOnandBy")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v("\n        " + _vm._s(_vm.lastUpdatedBy)),
                _c("br"),
                _vm._v(
                  _vm._s(
                    _vm.dateUtil.formatDate(
                      _vm.currentHotb.updatedAt,
                      true,
                      true
                    )
                  ) + "\n      "
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.allowEdit ? "general-info-edit" : "general-info-view" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isTenant,
                  expression: "isTenant",
                },
              ],
              staticClass: "handoverLastUpdateOn",
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("handover.lastUpdateOn")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.dateUtil.formatDate(
                        _vm.currentHotb.infoUpdatedAt ||
                          _vm.currentHotb.updatedAt,
                        true,
                        true
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isTenant,
                  expression: "isTenant",
                },
              ],
              staticClass: "tenancyBuilding",
            },
            [
              _c("div", { staticClass: "title" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.$t("tenancy.building")) + "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.deep(_vm.currentHotb, "tenancy.building.fullName")
                    ) +
                    "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "permisesName row" },
            [
              _c("TextField", {
                key: _vm.premisesNameKey,
                attrs: {
                  readonly: !_vm.allowEdit,
                  label: _vm.$t("handover.premises"),
                  showColon: false,
                  showFlag: _vm.allowEdit,
                  value: _vm.currentHotb.premises,
                  required: _vm.allowEdit,
                },
                on: { updateValue: _vm.updatePremises },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "floor" },
                [
                  _c("label", [_vm._v(_vm._s(_vm.$t("tenancy.floor")))]),
                  _vm._v(" "),
                  _vm.allowEdit
                    ? _c("HKLMultiSelect", {
                        staticClass: "multi-value",
                        attrs: {
                          value: _vm.floor,
                          options: _vm.floorHklOptions,
                          placeholder: "",
                        },
                        on: { change: _vm.onFloorChange },
                      })
                    : _c("TextField", {
                        attrs: {
                          readonly: true,
                          showColon: false,
                          showFlag: true,
                          value: _vm.showFloors(),
                        },
                      }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isTenant
            ? _c(
                "div",
                { staticClass: "date" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "title",
                      class: {
                        "required-flag":
                          _vm.allowEdit || (_vm.isEdit && _vm.allowEditDate),
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isHandover
                              ? _vm.$t("handover.date")
                              : _vm.$t("takeback.date")
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("DatePicker", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.allowEdit || (_vm.isEdit && _vm.allowEditDate),
                        expression: "allowEdit || (isEdit && allowEditDate)",
                      },
                    ],
                    class: _vm.invalidDateErrHighlightCls,
                    attrs: {
                      format: "DD MMM YY",
                      disabledPicker:
                        !_vm.allowEdit && !(_vm.isEdit && _vm.allowEditDate),
                      calendarButton: true,
                      clearButton:
                        _vm.allowEdit || (_vm.isEdit && _vm.allowEditDate),
                      disabled: {},
                      value: _vm.dateUtil.format(
                        _vm.currentHotb.transactionDate
                      ),
                      calendarButtonIcon: "fa fa-calendar",
                      placeholder: "",
                    },
                    on: {
                      selected: function (val) {
                        return _vm.updateField(["transactionDate"], val)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            !_vm.allowEdit &&
                            !(_vm.isEdit && _vm.allowEditDate),
                          expression:
                            "!allowEdit && !(isEdit && allowEditDate)",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.dateUtil.formatDate(
                            _vm.currentHotb.transactionDate
                          )
                        )
                      ),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.scheduledTransactionDate && _vm.isAfterScheduled
            ? _c("div", { staticClass: "scheduled-handover-date" }, [
                _c("label", [
                  _vm._v(
                    _vm._s(_vm.$t("handover.scheduledTransactionDateAndTime"))
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.formatDate(_vm.scheduledTransactionDate))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentHotb.completedDate
            ? _c("div", { staticClass: "date" }, [
                _c("div", { staticClass: "title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.isHandover
                          ? _vm.$t("handover.actualHandoverDate")
                          : _vm.$t("handover.actualTakebackDate")
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.dateUtil.formatDate(_vm.currentHotb.completedDate)
                    )
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isTenant,
                  expression: "!isTenant",
                },
              ],
              staticClass: "contact-info row",
            },
            [
              _vm.allowEdit
                ? _c(
                    "div",
                    { staticClass: "handover-contact row" },
                    [
                      _c(
                        "label",
                        {
                          class: [
                            { "required-flag": _vm.allowEdit },
                            "width100",
                          ],
                        },
                        [_vm._v(_vm._s(_vm.$t("handover.handoverContact")))]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.getFullnameSorts, function (fullnameObj) {
                        return _c("InputField", {
                          key: fullnameObj.key,
                          staticClass: "small-6 medium-6 large-6",
                          attrs: {
                            placeholder: _vm.$t(
                              "contact.basic." + fullnameObj.label
                            ),
                            showColon: false,
                            showFlag: false,
                            value: _vm.deep(
                              _vm.contacts,
                              "name." + fullnameObj.value
                            ),
                            required: "",
                          },
                          on: {
                            updateValue: function (val) {
                              return _vm.updateContact(
                                ["name", fullnameObj.value],
                                val
                              )
                            },
                          },
                        })
                      }),
                    ],
                    2
                  )
                : _c(
                    "div",
                    { staticClass: "handover-contact" },
                    [
                      _c("InputField", {
                        attrs: {
                          readonly: !_vm.allowEdit,
                          label: _vm.$t("handover.handoverContact"),
                          showColon: false,
                          showFlag: _vm.allowEdit,
                          value: _vm.getName() || "--",
                        },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _c("InputField", {
                staticClass: "phone-number",
                attrs: {
                  readonly: !_vm.allowEdit,
                  label: _vm.$t("user.phone"),
                  showColon: false,
                  showFlag: _vm.allowEdit,
                  value: _vm.getContactValue(_vm.contacts, "phone_number"),
                  required: "",
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateContact(["phone_number"], val)
                  },
                },
              }),
              _vm._v(" "),
              _c("InputField", {
                staticClass: "email",
                attrs: {
                  readonly: !_vm.allowEdit,
                  label: _vm.$t("user.email"),
                  showColon: false,
                  showFlag: _vm.allowEdit,
                  inputCheckType: "email",
                  inputTip: _vm.$t("hint.inputTip.email"),
                  pattern: _vm.regex.email,
                  value: _vm.getContactValue(_vm.contacts, "email"),
                  required: "",
                },
                on: {
                  updateValue: function (val) {
                    return _vm.updateContact(["email"], val)
                  },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hkldHotbContacts.length && _vm.isAfterScheduled,
                  expression: "hkldHotbContacts.length && isAfterScheduled",
                },
              ],
              staticClass: "handover-contacts-info",
            },
            [
              _vm.isTenant
                ? [
                    _c("div", { staticClass: "item" }, [
                      _c("label", [
                        _vm._v(_vm._s(_vm.$t("handover.handoverContact"))),
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.getName() || "--"))]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("label", [_vm._v(_vm._s(_vm.$t("user.phone")))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.getContactValue(_vm.contacts, "phone_number") ||
                              "--"
                          )
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "item" }, [
                      _c("label", [_vm._v(_vm._s(_vm.$t("user.email")))]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.getContactValue(_vm.contacts, "email"))
                        ),
                      ]),
                    ]),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.hkldHotbContacts, function (item, index) {
                return _c("div", { key: index }, [
                  _c("div", { staticClass: "item" }, [
                    !index
                      ? _c("label", [
                          _vm._v(_vm._s(_vm.$t("handover.hkldContact"))),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.getDisplayName(item)))]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    !index
                      ? _c("label", [_vm._v(_vm._s(_vm.$t("user.phone")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.getHkldUserInfo(item, "PHONE_NUMBER") || "--"
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item" }, [
                    !index
                      ? _c("label", [_vm._v(_vm._s(_vm.$t("user.email")))])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.getHkldUserInfo(item, "EMAIL"))),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.hkldHotbContacts.length && _vm.isAfterScheduled,
                  expression: "hkldHotbContacts.length && isAfterScheduled",
                },
              ],
              staticClass: "remark-to-tenant",
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("handover.remarkToTenant")))]),
              _vm._v(" "),
              _c("pre", [_vm._v(_vm._s(_vm.remarkToTenant || "--"))]),
            ]
          ),
          _vm._v(" "),
          _vm.isTenant
            ? _c(
                "div",
                { staticClass: "attachments attach-to-tenant" },
                [
                  _c("div", { staticClass: "title" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("handover.attachmentsForTenant")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("EditAttachments", {
                    attrs: {
                      sourceId: _vm.pubDocResourceId,
                      canEdit: false,
                      getFileLengthID: _vm.pubDocResourceId,
                      canDelete: _vm.allowEditDocs,
                      canDownloadAll: false,
                      filesChanged: _vm.tenantFilesChanged,
                      updateDescriptionCb: _vm.tenantUpdateDescriptionCb,
                    },
                  }),
                  _vm._v(" "),
                  _vm.isEmptyAttachmentsForTenant
                    ? _c("span", [_vm._v("--")])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isTenant ? _c("hr") : _vm._e(),
          _vm._v(" "),
          !_vm.isTenant
            ? _c("p", { staticClass: "internal-only" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("handover.internalUseOnly")) +
                    "\n    "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.isTenant
            ? _c("div", { staticClass: "premisesRemark" }, [
                _c(
                  "label",
                  {
                    staticClass: "emphasis",
                    class: { "required-flag": _vm.allowEdit && _vm.isOthers },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "handover.handoverSchedule.conditionOfPremises"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "radio" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowEdit ? true : _vm.isAsIs,
                        expression: "allowEdit ? true : isAsIs",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.premiseBuildingType,
                        expression: "premiseBuildingType",
                      },
                    ],
                    attrs: { type: "radio", disabled: !_vm.allowEdit },
                    domProps: {
                      value: _vm.hotbPremiseBuildingType.asIs,
                      checked: _vm._q(
                        _vm.premiseBuildingType,
                        _vm.hotbPremiseBuildingType.asIs
                      ),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.premiseBuildingType =
                            _vm.hotbPremiseBuildingType.asIs
                        },
                        function ($event) {
                          return _vm.updateField(
                            ["premiseBuildingType"],
                            _vm.premiseBuildingType
                          )
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowEdit ? true : _vm.isAsIs,
                          expression: "allowEdit ? true : isAsIs",
                        },
                      ],
                      class: { "en-bold": _vm.isAsIs },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("customValueByKey")(
                              _vm.hotbPremiseBuildingType.asIs,
                              {
                                obj: _vm.hotbPremiseBuildingType,
                                rootPath: "handover",
                              }
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowEdit ? true : _vm.isBareShell,
                        expression: "allowEdit ? true : isBareShell",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.premiseBuildingType,
                        expression: "premiseBuildingType",
                      },
                    ],
                    attrs: { type: "radio", disabled: !_vm.allowEdit },
                    domProps: {
                      value: _vm.hotbPremiseBuildingType.bareShell,
                      checked: _vm._q(
                        _vm.premiseBuildingType,
                        _vm.hotbPremiseBuildingType.bareShell
                      ),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.premiseBuildingType =
                            _vm.hotbPremiseBuildingType.bareShell
                        },
                        function ($event) {
                          return _vm.updateField(
                            ["premiseBuildingType"],
                            _vm.premiseBuildingType
                          )
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowEdit ? true : _vm.isBareShell,
                          expression: "allowEdit ? true : isBareShell",
                        },
                      ],
                      class: { "en-bold": _vm.isBareShell },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("customValueByKey")(
                              _vm.hotbPremiseBuildingType.bareShell,
                              {
                                obj: _vm.hotbPremiseBuildingType,
                                rootPath: "handover",
                              }
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.allowEdit ? true : _vm.isOthers,
                        expression: "allowEdit ? true : isOthers",
                      },
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.premiseBuildingType,
                        expression: "premiseBuildingType",
                      },
                    ],
                    attrs: { type: "radio", disabled: !_vm.allowEdit },
                    domProps: {
                      value: _vm.hotbPremiseBuildingType.others,
                      checked: _vm._q(
                        _vm.premiseBuildingType,
                        _vm.hotbPremiseBuildingType.others
                      ),
                    },
                    on: {
                      change: [
                        function ($event) {
                          _vm.premiseBuildingType =
                            _vm.hotbPremiseBuildingType.others
                        },
                        function ($event) {
                          return _vm.updateField(
                            ["premiseBuildingType"],
                            _vm.premiseBuildingType
                          )
                        },
                      ],
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.allowEdit ? true : _vm.isOthers,
                          expression: "allowEdit ? true : isOthers",
                        },
                      ],
                      class: { "en-bold": _vm.isOthers },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("customValueByKey")(
                              _vm.hotbPremiseBuildingType.others,
                              {
                                obj: _vm.hotbPremiseBuildingType,
                                rootPath: "handover",
                              }
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                (_vm.isTenant || !_vm.allowEdit) && _vm.premisesRemark
                  ? _c("pre", [_vm._v(_vm._s(_vm.premisesRemark))])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isTenant && _vm.allowEdit
                  ? _c("textarea", {
                      directives: [
                        { name: "autosize", rawName: "v-autosize" },
                        {
                          name: "fusioninputcheck",
                          rawName: "v-fusioninputcheck",
                          value: {
                            type: "string",
                            required: _vm.allowEdit && _vm.isOthers,
                          },
                          expression:
                            "{type: 'string', required: allowEdit && isOthers}",
                        },
                      ],
                      staticClass: "autosize",
                      attrs: {
                        disabled: !_vm.allowEdit,
                        placeholder: _vm._f("customValueByKey")(
                          _vm.premiseBuildingType,
                          {
                            obj: _vm.hotbPremiseBuildingType,
                            rootPath: "handover",
                          }
                        ),
                        required: _vm.allowEdit && _vm.isOthers,
                      },
                      domProps: { value: _vm.premisesRemark },
                      on: {
                        change: function (event) {
                          return _vm.updateField(
                            ["premisesRemark"],
                            event.target.value
                          )
                        },
                      },
                    })
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isTenant,
                  expression: "!isTenant",
                },
              ],
              staticClass: "special-remark",
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("handover.specialRemark")))]),
              _vm._v(" "),
              !_vm.isTenant
                ? _c("TextField", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.allowEdit || (_vm.isEdit && _vm.allowApprove),
                        expression: "allowEdit || (isEdit && allowApprove)",
                      },
                    ],
                    attrs: { showColon: false, value: _vm.currentHotb.remarks },
                    on: {
                      updateValue: function (val) {
                        return _vm.updateField(["remarks"], val)
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "pre",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        !_vm.allowEdit && !(_vm.isEdit && _vm.allowApprove),
                      expression: "!allowEdit && !(isEdit && allowApprove)",
                    },
                  ],
                },
                [_vm._v(_vm._s(_vm.currentHotb.remarks || "--"))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isHKlandUser,
                  expression: "isHKlandUser",
                },
              ],
              staticClass: "attachments otherDocuments",
            },
            [
              _vm.isHKlandUser
                ? _c(
                    "div",
                    {
                      staticClass: "title",
                      class: { "required-flag": _vm.allowEdit },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("handover.otherDocuments")) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.allowEditDocs
                ? _c("HkldDropzone", { attrs: { sourceId: _vm.hotbId } })
                : _vm._e(),
              _vm._v(" "),
              _vm.isHKlandUser
                ? _c("EditAttachments", {
                    attrs: {
                      sourceId: _vm.hotbId,
                      canEdit: _vm.allowEditDocs,
                      filesChanged: _vm.filesChanged,
                      canDelete: _vm.allowEditDocs,
                      canDownloadAll: false,
                      getFileLengthID: _vm.hotbId,
                      updateDescriptionCb: _vm.updateDescriptionCb,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.isEmptyAttachments && _vm.isWappr
                ? _c("span", [_vm._v("--")])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "reveal", attrs: { id: "fillInContactInfoModal" } },
        [
          _c("InviteContactModal", {
            attrs: {
              closeModal: _vm.closeInviteModal,
              hkldUserSelectOptions: _vm.hkldUserSelectOptions,
              hkldHotbContacts: _vm.hkldHotbContacts,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("Lifecycle", {
        ref: "handoverLifecycle",
        attrs: {
          modalId: "handover-takeback-modules-lifecycle-modal",
          type: _vm.isHandover ? "handover" : "takeback",
          commentAttr: _vm.lifecycleCommentAttrs.comments,
          histories: _vm.currentHotb.histories || [],
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }